<template>
  <div>

    <div class="detailsbox">
      <div class="titlebox">
        <div class="title">{{ resData.title }}</div>
        <!-- <div @click="addFavorite(resData.title)" class="shoucang">
          <img src="@/assets/img/icon-collection.png" alt="" class="ico">
          收藏
          <img src="@/assets/img/icon-collection.png" alt="" class="ico"> 
           <img src="@/assets/img/icon-collection-sel.png" alt="" class="ico">
        </div> -->
      </div>
      <div class="contentbox">
        <div v-html="resData.content_html"></div>
      </div>

      <div v-if="resData.previous_article || resData.next_article" class="pagetitlebox">
        <router-link v-if="resData.previous_article"
          :to='{ "name": "details", query: { id: resData.previous_article.id } }'>上一篇：{{ resData.previous_article.title
          }}</router-link>
        <router-link v-if="resData.next_article"
          :to='{ "name": "details", query: { id: resData.next_article.id } }'>下一篇：{{ resData.next_article.title
          }}</router-link>
      </div>
    </div>


  </div>
</template>

<script>
import { supplierRuleDetail } from "@/server/api/index"
export default {
  name: 'Index',
  components: {},

  data() {
    return {
      resData: {}
    };
  },
  watch: {
    $route(to, from) {
      this.init()
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      // console.log('this.$router', this.$route.query)
      supplierRuleDetail(this.$route.query).then(res => {
        if (this.$route.query.name) {
          // console.log('this.$route.query.name', this.$route.query.name)
          setTimeout(() => {
            const elements = document.getElementsByName(this.$route.query.name);
            if(elements.length>0){
              document.documentElement.scrollTop = elements[0].offsetTop
            }else{
              document.documentElement.scrollTop = 0
            }
          }, 100)
        } else {
          document.documentElement.scrollTop = 0
        }
        this.resData = res.data.detail

        // category
        this.$emit(
          "result",
          'details',
          res.data.detail.category
        )
      })
    },
    //收藏本站
    addFavorite(title) {
      let url = location.href
      try {
        window.external.addFavorite(url, title);
      } catch (e) {
        try {
          window.sidebar.addPanel(title, url, "");
        } catch (e) {
          alert("抱歉，您所使用的浏览器无法完成此操作。\n\n加入收藏失败，请使用Ctrl+D进行添加");
        }
      }
    },

  },
}
</script>

<style lang='less' scoped>
.detailsbox {
  .titlebox {
    padding: 24px 30px 0 30px;
    display: flex;
    align-items: center;

    .title {
      font-size: 20px;
      color: #222222;
      font-weight: bold;
    }

    // .shoucang {
    //   width: 55px;
    //   height: 24px;
    //   background: #FFFFFF;
    //   border-radius: 4px;
    //   border: 1px solid #DCDFE6;
    //   margin-left: 10px;
    //   display: flex;
    //   align-items: center;
    //   justify-content: center;
    //   font-size: 14px;
    //   color: #AAAAAA;

    //   .ico {
    //     width: 12px;
    //     height: 12px;
    //     display: block;
    //     margin-right: 4px;
    //   }

    //   &.cur {
    //     color: #FF9764;
    //     border-color: #FF9764;
    //   }
    // }
  }

  .contentbox {
    margin: 20px 30px;

    @media screen and (min-width: 1260px) {
      min-height: calc(100vh - 120px - 164px);
    }

    ::v-deep {
      img {
        max-width: 100%;
      }

      table {
        max-width: 100%;

        th,
        td {
          max-width: 100%;
        }
      }
    }
  }

  .pagetitlebox {
    border-top: 1px solid #EFEFEF;
    padding: 20px 0 20px 20px;
    font-size: 14px;


    // color: #1667FF;
    a {
      margin-right: 40px;
      color: #222;

      &:hover {
        color: #1667FF;
      }
    }
  }
}

@media screen and (max-width: 1259px) {
  .detailsbox {
    .pagetitlebox {
      padding: 10px 0 10px 20px;

      a {
        display: block;
        margin: 10px 0;
      }
    }

    .contentbox {
      overflow: hidden;
    }
  }
}
</style>
